import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import {
    AtSign,
    Dribbble,
    GitHub,
    Gitlab,
    Instagram,
    MessageCircle,
    Send,
    Twitter,
} from 'react-feather';
import { Link } from 'react-router-dom';

export default function Button() {
    return (
        <>
            <Container fluid>
                <Col>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>دکمه ها</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>کامپوننت ها</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/button'>دکمه ها</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </Col>

                <div className='space-20' />

                <Row>
                    <Col sm={12} xxl={6} className='mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                دکمه های رنگی و معمولی
                            </div>

                            <Card.Body>
                                <button
                                    type='button'
                                    className='btn btn-primary mr-2 mb-2'
                                >
                                    اصلی
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-secondary mr-2 mb-2'
                                >
                                    ثانوی
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-success mr-2 mb-2'
                                >
                                    موفقیت آمیز
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-danger mr-2 mb-2'
                                >
                                    اخطار
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-warning mr-2 mb-2'
                                >
                                    هشدار
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-info mr-2 mb-2'
                                >
                                    اطلاعات
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-light mr-2 mb-2'
                                >
                                    روشن
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-dark mr-2 mb-2'
                                >
                                    تیره
                                </button>
                            </Card.Body>
                        </Card>
                    </Col>

                    <div className='col-sm-12 col-xxl-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                دکمه های بدون پس زمینه
                            </div>

                            <Card.Body>
                                <button
                                    type='button'
                                    className='btn btn-outline-primary mr-2 mb-2'
                                >
                                    اصلی
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-secondary mr-2 mb-2'
                                >
                                    ثانوی
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-success mr-2 mb-2'
                                >
                                    موفقیت آمیز
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-danger mr-2 mb-2'
                                >
                                    اخطار
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-warning mr-2 mb-2'
                                >
                                    هشدار
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-info mr-2 mb-2'
                                >
                                    اطلاعات
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-light mr-2 mb-2'
                                >
                                    روشن
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-dark mr-2 mb-2'
                                >
                                    تیره
                                </button>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className='col-sm-12 col-xxl-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                دکمه های آبشاری
                            </div>

                            <Card.Body>
                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-primary mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        اصلی
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-secondary mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        ثانوی
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-success mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        موفقیت آمیز
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-danger mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        اخطار
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-warning mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        هشدار
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-info mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        اطلاعات
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-light mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        روشن
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-dark mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        تیره
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className='col-sm-12 col-xxl-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                دکمه های بدون پس زمینه آبشاری
                            </div>

                            <Card.Body>
                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-outline-primary mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        اصلی
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-outline-secondary mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        ثانوی
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-outline-success mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        موفقیت آمیز
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-outline-danger mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        اخطار
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-outline-warning mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        هشدار
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-outline-info mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        اطلاعات
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-outline-light mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        روشن
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className='btn-group'>
                                    <button
                                        type='button'
                                        className='btn btn-outline-dark mr-2 mb-2 dropdown-toggle'
                                        data-bs-toggle='dropdown'
                                        aria-expanded='false'
                                    >
                                        تیره
                                    </button>

                                    <ul className='dropdown-menu dropdown-menu-end'>
                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                یک لینک دیگه
                                            </Link>
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک اضافه
                                            </Link>
                                        </li>

                                        <li>
                                            <hr className='dropdown-divider' />
                                        </li>

                                        <li>
                                            <Link
                                                className='dropdown-item'
                                                to='/'
                                            >
                                                لینک جداگونه
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className='col-sm-12 col-xxl-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                دکمه دارای آیکون
                            </div>

                            <Card.Body>
                                <button
                                    type='button'
                                    className='btn btn-primary mr-2 mb-2'
                                >
                                    <Send className='mr-2' size={17} />
                                    تلگرام
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-secondary mr-2 mb-2'
                                >
                                    <Instagram className='mr-2' size={17} />
                                    اینستاگرام
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-success mr-2 mb-2'
                                >
                                    <MessageCircle className='mr-2' size={17} />
                                    واتس آپ
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-danger mr-2 mb-2'
                                >
                                    <AtSign className='mr-2' size={17} />
                                    جیمیل
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-warning mr-2 mb-2'
                                >
                                    <Gitlab className='mr-2' size={17} />
                                    گیت لب
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-info mr-2 mb-2'
                                >
                                    <Twitter className='mr-2' size={17} />
                                    توییتر
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-light mr-2 mb-2'
                                >
                                    <Dribbble className='mr-2' size={17} />
                                    دریبل
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-dark mr-2 mb-2'
                                >
                                    <GitHub className='mr-2' size={17} />
                                    گیت هاب
                                </button>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className='col-sm-12 col-xxl-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                دکمه دارای آیکون
                            </div>

                            <Card.Body>
                                <button
                                    type='button'
                                    className='btn btn-primary mr-2 mb-2'
                                >
                                    <Send size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-secondary mr-2 mb-2'
                                >
                                    <Instagram size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-success mr-2 mb-2'
                                >
                                    <MessageCircle size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-danger mr-2 mb-2'
                                >
                                    <AtSign size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-warning mr-2 mb-2'
                                >
                                    <Gitlab size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-info mr-2 mb-2'
                                >
                                    <Twitter size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-light mr-2 mb-2'
                                >
                                    <Dribbble size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-dark mr-2 mb-2'
                                >
                                    <GitHub size={17} />
                                </button>

                                <br />

                                <button
                                    type='button'
                                    className='btn btn-outline-primary mr-2 mb-2'
                                >
                                    <Send size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-secondary mr-2 mb-2'
                                >
                                    <Instagram size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-success mr-2 mb-2'
                                >
                                    <MessageCircle size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-danger mr-2 mb-2'
                                >
                                    <AtSign size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-warning mr-2 mb-2'
                                >
                                    <Gitlab size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-info mr-2 mb-2'
                                >
                                    <Twitter size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-light mr-2 mb-2'
                                >
                                    <Dribbble size={17} />
                                </button>

                                <button
                                    type='button'
                                    className='btn btn-outline-dark mr-2 mb-2'
                                >
                                    <GitHub size={17} />
                                </button>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className='col-sm-12 col-xxl-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                انواع دکمه های گروهی
                            </div>

                            <Card.Body>
                                <div
                                    className='btn-group mr-2 mb-2'
                                    role='group'
                                    aria-label='Basic example'
                                >
                                    <button
                                        type='button'
                                        className='btn btn-primary'
                                    >
                                        چپ
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-primary'
                                    >
                                        وسط
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-primary'
                                    >
                                        راست
                                    </button>
                                </div>

                                <div
                                    className='btn-group mr-2 mb-2'
                                    role='group'
                                    aria-label='Basic outlined example'
                                >
                                    <button
                                        type='button'
                                        className='btn btn-outline-primary'
                                    >
                                        چپ
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-outline-primary'
                                    >
                                        وسط
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-outline-primary'
                                    >
                                        راست
                                    </button>
                                </div>

                                <div
                                    className='btn-group mb-2'
                                    role='group'
                                    aria-label='Basic mixed styles example'
                                >
                                    <button
                                        type='button'
                                        className='btn btn-danger'
                                    >
                                        چپ
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-warning'
                                    >
                                        وسط
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-success'
                                    >
                                        راست
                                    </button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className='col-sm-12 col-xxl-6 mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                دکمه های رادیویی و چک باکس گروهی
                            </div>

                            <Card.Body>
                                <div
                                    className='btn-group mr-2 mb-2'
                                    role='group'
                                    aria-label='Basic checkbox toggle button group'
                                >
                                    <input
                                        type='checkbox'
                                        className='btn-check'
                                        id='btncheck1'
                                        autoComplete='off'
                                    />
                                    <label
                                        className='btn btn-outline-primary'
                                        htmlFor='btncheck1'
                                    >
                                        چک باکس 1
                                    </label>

                                    <input
                                        type='checkbox'
                                        className='btn-check'
                                        id='btncheck2'
                                        autoComplete='off'
                                    />
                                    <label
                                        className='btn btn-outline-primary'
                                        htmlFor='btncheck2'
                                    >
                                        چک باکس 2
                                    </label>

                                    <input
                                        type='checkbox'
                                        className='btn-check'
                                        id='btncheck3'
                                        autoComplete='off'
                                    />
                                    <label
                                        className='btn btn-outline-primary'
                                        htmlFor='btncheck3'
                                    >
                                        چک باکس 3
                                    </label>
                                </div>

                                <div
                                    className='btn-group mb-2'
                                    role='group'
                                    aria-label='Basic radio toggle button group'
                                >
                                    <input
                                        type='radio'
                                        className='btn-check'
                                        name='btnradio'
                                        id='btnradio1'
                                        autoComplete='off'
                                        defaultChecked
                                    />
                                    <label
                                        className='btn btn-outline-danger'
                                        htmlFor='btnradio1'
                                    >
                                        رادیو ۱
                                    </label>

                                    <input
                                        type='radio'
                                        className='btn-check'
                                        name='btnradio'
                                        id='btnradio2'
                                        autoComplete='off'
                                    />
                                    <label
                                        className='btn btn-outline-danger'
                                        htmlFor='btnradio2'
                                    >
                                        رادیو 2
                                    </label>

                                    <input
                                        type='radio'
                                        className='btn-check'
                                        name='btnradio'
                                        id='btnradio3'
                                        autoComplete='off'
                                    />
                                    <label
                                        className='btn btn-outline-danger'
                                        htmlFor='btnradio3'
                                    >
                                        رادیو 3
                                    </label>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
}
